import React from "react";

function Footer() {
  return (
      <footer className="footer py-3 bg-light fixed-bottom">
        <div className="container text-center">
          <span className="text-muted ">
            Copyright 2020-2021 &copy; Sat-Sid
          </span>
        </div>
      </footer>
  );
}

export default Footer;
